import {createContext} from 'react'

const AnnouncementReadyContext = createContext(false)

export default AnnouncementReadyContext
